import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from "../ui/breadcrumb";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

export const BreadcrumbBar = () => {
    const router = useLocation().pathname.split("/");
    return (
        <Breadcrumb className="hidden md:flex">
            <BreadcrumbList>
                {router.map(
                    (segment, id) =>
                        segment != "" && (
                            <>
                                <BreadcrumbItem key={id} className="capitalize">
                                    {id != router.length - 1 ? (
                                        <BreadcrumbLink asChild>
                                            <Link
                                                to={`/${
                                                    id == 1
                                                        ? "dashboard"
                                                        : "dashboard/" + segment
                                                }`}
                                            >
                                                {segment}
                                            </Link>
                                        </BreadcrumbLink>
                                    ) : (
                                        <BreadcrumbPage>
                                            {segment}
                                        </BreadcrumbPage>
                                    )}
                                </BreadcrumbItem>
                                {id != router.length - 1 && (
                                    <BreadcrumbSeparator />
                                )}
                            </>
                        )
                )}
            </BreadcrumbList>
        </Breadcrumb>
    );
};
